import React from 'react';
import { Button, Empty } from 'antd';
import { EMPTY_COPY, SCENE_COPY } from '../utils/businessContextNav';

/**
 * 全局标准空态 / 场景反馈。
 * variant:
 * - notConnected | noRecord（业务空数据）
 * - offline | noAccess | loadError（断网 / 无权限 / 加载失败，可带重试）
 */
export default function StandardEmpty({
  variant = 'noRecord',
  className = '',
  image,
  onRetry,
  retryText = '重试',
  description: descriptionOverride,
} = {}) {
  const map = {
    notConnected: EMPTY_COPY.NOT_CONNECTED,
    noRecord: EMPTY_COPY.NO_RECORD,
    offline: SCENE_COPY.OFFLINE,
    noAccess: SCENE_COPY.NO_ACCESS,
    loadError: SCENE_COPY.LOAD_ERROR,
  };
  const description = descriptionOverride || map[variant] || EMPTY_COPY.NO_RECORD;

  return (
    <div className={className}>
      <Empty
        image={image === undefined ? Empty.PRESENTED_IMAGE_SIMPLE : image}
        description={
          <div className="space-y-2">
            <div>{description}</div>
            {typeof onRetry === 'function' ? (
              <Button type="primary" size="small" onClick={onRetry}>
                {retryText}
              </Button>
            ) : null}
          </div>
        }
      />
    </div>
  );
}

export { EMPTY_COPY, SCENE_COPY };
